import { useState } from "react";
import { ChatCircleDots, X, PaperPlaneRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function LiveChatWidget() {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                onClick={() => setOpen(!open)}
                className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full flex items-center justify-center pulse-ring"
                style={{
                    background: "linear-gradient(135deg, #06b6d4 0%, #3b82f6 100%)",
                    boxShadow: "0 10px 30px -10px rgba(6,182,212,0.7)",
                    color: "#020617",
                }}
                data-testid="live-chat-toggle"
                aria-label="Open chat"
            >
                {open ? <X size={24} weight="bold" /> : <ChatCircleDots size={26} weight="fill" />}
            </button>
            {open && (
                <div
                    className="fixed bottom-24 right-6 z-50 w-[min(360px,calc(100vw-2rem))] rounded-2xl overflow-hidden tech-card"
                    data-testid="live-chat-panel"
                >
                    <div className="p-4 border-b border-slate-800 bg-slate-900/80">
                        <div className="flex items-center gap-3">
                            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-cyan-400 to-blue-500 flex items-center justify-center text-slate-900 font-bold text-sm">S2</div>
                            <div>
                                <div className="font-heading font-semibold text-slate-100 text-sm">Surveys2CAD Team</div>
                                <div className="text-xs text-emerald-400 flex items-center gap-1.5">
                                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" /> Online — replies in minutes
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="p-4 space-y-3 bg-slate-950/40 min-h-[180px]">
                        <div className="bg-slate-800/60 rounded-2xl rounded-bl-sm px-3 py-2 text-sm text-slate-200 max-w-[85%]">
                            Hi there 👋 — which CAD drafting service are you looking for? Boundary, Topo, ALTA, or something else?
                        </div>
                        <div className="bg-slate-800/60 rounded-2xl rounded-bl-sm px-3 py-2 text-sm text-slate-200 max-w-[85%]">
                            Share your project details and we'll get back with a quote & turnaround within 1 business hour.
                        </div>
                    </div>
                    <div className="p-3 border-t border-slate-800 bg-slate-900/80">
                        <Link
                            to="/get-started"
                            onClick={() => setOpen(false)}
                            className="btn-primary w-full justify-center text-sm"
                            data-testid="live-chat-get-started-btn"
                        >
                            Start a Project <PaperPlaneRight size={14} weight="bold" />
                        </Link>
                        <p className="text-[11px] text-slate-500 mt-2 text-center">
                            Or email <span className="text-cyan-400">surveys2cad@gmail.com</span>
                        </p>
                    </div>
                </div>
            )}
        </>
    );
}
